module.exports = __webpack_public_path__ + "static/media/25488297_1703485569726627_3609499319019598544_o.1570a3c5.jpg";